<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2" id="r9780062322470_Contents_toc_6"><a id="page_XIII"></a><a id="page_XIV"></a><a href="#/text/9780062322470_Contents#I9780062322470_Contents_toc_6"><span class="small">PART ONE</span></a></h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780062322470_Part_1.vue?bff0b8b2